import CONSTANT from '../constant/index'
import Api from '../lib/request'
import cookie from '../lib/cookie'
import qs from 'querystring'

const getOpenId = (code) => {
  const str = `${CONSTANT.REQUEST_HOST}?${qs.stringify({ code, platformType: 'wechat_kaop' })}`
  return new Promise((resolve, reject) => {
    Api.get(str, {
      headers: {
        'Content-Type': 'application/json',
        'X-Host': 'kaop.user.openid',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) || '',
      },
    }).then(
      (data) => {
        if (data.status === 0) {
          return resolve(data.data)
        }
        return reject(data)
      },
      (e) => {
        reject(e)
      },
    )
  })
}

const wechatAutoLogin = (options) => {
  return new Promise((resolve, reject) => {
    Api.post(CONSTANT.REQUEST_HOST, options, {
      headers: {
        'Content-Type': 'application/json',
        'X-Host': 'kaop.user.wechat-login',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) || '',
      },
    }).then(
      (data) => {
        if (data.status === 0) {
          return resolve(data.data)
        }
        return reject(data)
      },
      (e) => {
        reject(e)
      },
    )
  })
}

/**
 * 星享福微信统一登陆
 */
const wechatUnifyLogin = (options) => {
  return new Promise((resolve, reject) => {
    Api.post(CONSTANT.REQUEST_HOST, options, {
      headers: {
        'Content-Type': 'application/json',
        'X-Host': 'kaop.user.xxf.wechat-public-login',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) || '',
      },
    }).then(
      (data) => {
        if (data.status === 0) {
          return resolve(data.data)
        }
        return reject(data)
      },
      (e) => {
        reject(e)
      },
    )
  })
}

// 微信 openId 单独绑定
const bindOpenId = (options) => {
  return new Promise((resolve, reject) => {
    Api.post(CONSTANT.REQUEST_HOST, options, {
      headers: {
        'Content-Type': 'application/json',
        'X-Host': 'kaop.user.bind.open-id',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) || '',
      },
    }).then(
      (data) => {
        if (data.status === 0) {
          return resolve(data.data)
        }
        return reject(data)
      },
      (e) => {
        reject(e)
      },
    )
  })
}

// 根据手机号码查询已绑定的 openId 信息
const getWechatBindInfo = (options) => {
  let url = CONSTANT.REQUEST_HOST
  return new Promise((resolve, reject) => {
    Api.post(url, JSON.stringify(options), {
      headers: {
        'Content-Type': 'application/json',
        'X-Host': 'kaop.user.wehat-bind-info',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) || '',
      },
    }).then(
      (data) => {
        if (data.status === 0) {
          return resolve(data.data)
        }
        return reject(data)
      },
      (e) => {
        reject(e)
      },
    )
  })
}

// 绑定手机页-解除手机号码与微信的绑定
const mobileUnbindWechat = (options) => {
  let url = CONSTANT.REQUEST_HOST
  return new Promise((resolve, reject) => {
    Api.post(url, JSON.stringify(options), {
      headers: {
        'Content-Type': 'application/json',
        'X-Host': 'kaop.user.mobile-wechat-unbind',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) || '',
      },
    }).then(
      (data) => {
        if (data.status === 0) {
          resolve(data.data)
        } else {
          reject(data)
        }
      },
      (e) => {
        reject(e)
      },
    )
  })
}

// 星享福公众号 code 换取 openId（统一登录）
const queryOpenIdWithCode = (options) => {
  let url = CONSTANT.REQUEST_HOST
  return new Promise((resolve, reject) => {
    Api.post(url, JSON.stringify(options), {
      headers: {
        'Content-Type': 'application/json',
        'X-Host': 'kaop.user.xxf.openid-with-code.query',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) || '',
      },
    }).then(
      (data) => {
        if (data.status === 0) {
          resolve(data.data)
        } else {
          reject(data)
        }
      },
      (e) => {
        reject(e)
      },
    )
  })
}

// 查询手机号码是否已绑定微信 openId公共登录
const queryWechatBindMobile = (options) => {
  let url = CONSTANT.REQUEST_HOST
  return new Promise((resolve, reject) => {
    Api.post(url, JSON.stringify(options), {
      headers: {
        'Content-Type': 'application/json',
        'X-Host': 'kaop.user.xxf.wechat-bind-mobile.query',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) || '',
      },
    }).then(
      (data) => {
        if (data.status === 0) {
          resolve(data.data)
        } else {
          reject(data)
        }
      },
      (e) => {
        reject(e)
      },
    )
  })
}

// 解除微信公共登录页手机绑定
const cancelWechatBindMobile = (options) => {
  let url = CONSTANT.REQUEST_HOST
  return new Promise((resolve, reject) => {
    Api.post(url, JSON.stringify(options), {
      headers: {
        'Content-Type': 'application/json',
        'X-Host': 'kaop.user.xxf.wechat-bind-mobile.cacel',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) || '',
      },
    }).then(
      (data) => {
        if (data.status === 0) {
          resolve(data.data)
        } else {
          reject(data)
        }
      },
      (e) => {
        reject(e)
      },
    )
  })
}

export default {
  getOpenId,
  wechatAutoLogin,
  wechatUnifyLogin,
  bindOpenId,
  getWechatBindInfo,
  mobileUnbindWechat,
  queryOpenIdWithCode,
  queryWechatBindMobile,
  cancelWechatBindMobile,
}
